import { times } from "lodash";
import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";
import { getUserInfo, refreshToken } from "./Auth";

export const getAllAuthorExplore = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/author/explore?page=${page}&rowsPerPage=${rowsPerPage}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorProfileSummaryByID = (id, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/author/summary?authorId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorKeywordsByID = (
  id,
  timeSpan,
  granularityLevel,
  params,
  verified,
  callback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/keyword_cloud?authorId=${id}&verify=${verified}`;
  if (timeSpan) {
    url += `&fromYear=${timeSpan[0]}&toYear=${timeSpan[1]}`;
  }
  if (granularityLevel !== null) {
    url += `&granularityLevel=${granularityLevel - 1}`;
  }
  if (params) {
    url += `&${params}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorGrantsKeywordsByID = (
  id,
  timeSpan,
  granularityLevel,
  params,
  callback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/grants_keyword_cloud?authorId=${id}`;
  if (timeSpan) {
    url += `&fromYear=${timeSpan[0]}&toYear=${timeSpan[1]}`;
  }
  if (granularityLevel !== null) {
    url += `&granularityLevel=${granularityLevel - 1}`;
  }
  if (params) {
    url += `&${params}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorPublicationsByID = (
  id,
  page,
  rowsPerPage,
  timeSpan,
  keywords,
  verified,
  callback,
  errorCallback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/publications?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}&verify=${verified}&order_by=publication_year&order=desc`;
  if (timeSpan) {
    url += `&fromYear=${timeSpan[0]}&toYear=${timeSpan[1]}`;
  }
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      errorCallback?.(err);
    });
};

export const getAuthorExperiencesByID = (
  id,
  page,
  rowsPerPage,
  timeSpan,
  callback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/experience?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;
  if (timeSpan) {
    url += `&fromYear=${times[0]}&toYear=${timeSpan[1]}`;
  }

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getAuthorAcclaimAchievementsByID = (id, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/author/acclaim_achievements?authorId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response?.status === 401) {
        refreshToken(() => getUserInfo(callback));
      } else {
        callback(err.response?.data);
      }
    });
};
export const getAuthorHonorsByID = (id, page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/author/honor_awards?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorAwardsByID = (
  id,
  page,
  rowsPerPage,
  timeSpan,
  keywords,
  callback,
  errCallback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/awarded_grants?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;
  if (timeSpan) {
    url += `&fromYear=${timeSpan[0]}&toYear=${timeSpan[1]}`;
  }
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      errCallback?.(err);
    });
};

export const getAuthorPeersByID = (
  id,
  page,
  rowsPerPage,
  timeSpan,
  callback,
) => {
  const axios = AxiosConfigExplore();
  const url = `/author/peers?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;
  if (timeSpan) {
    url += `&fromYear=${times[0]}&toYear=${timeSpan[1]}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorCollaboratorsByID = (
  id,
  institutionId,
  institutionIdExclude,
  keywords,
  page,
  rowsPerPage,
  callback,
  errCallback,
) => {
  const axios = AxiosConfigExplore();
  let url = `/author/collaborators?authorId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;
  if (institutionId) {
    url += `&institutionId=${institutionId}`;
  }
  if (institutionIdExclude) {
    url += `&institutionIdExclude=${institutionIdExclude}`;
  }
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      errCallback?.(err);
    });
};

export const getAuthorCollaboratorGraphById = async ({
  id,
  institutionId,
  institutionIdExclude,
  unit,
  keywords,
  top_k,
  top_k_edges,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/collaborators_graph?authorId=${id}`;
  if (institutionId) {
    url += `&institutionId=${institutionId}`;
  }
  if (institutionIdExclude) {
    url += `&institutionIdExclude=${institutionIdExclude}`;
  }
  if (unit) {
    url += `&department=${unit}`;
  }
  if (keywords?.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }
  if (top_k) {
    url += `&top_k=${top_k}`;
  }
  if (top_k_edges) {
    url += `&top_k_edges=${top_k_edges}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getSearchAuthors = async (data) => {
  const { query, ...rest } = data;
  const axios = AxiosConfigExplore();
  let url = `/author/search`;

  try {
    const res = await axios.post(url, {
      ...rest,
      query: Array.isArray(query) ? query : !!query ? [query] : null,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacetSearchAuthorKeywords = async ({
  keywordTimeFilter,
  top_k,
  institution_ids,
  seniority,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/facet_search/keywords`;
  const searchParams = new URLSearchParams();
  if (keywordTimeFilter) {
    searchParams.append("keywordTimeFilter", keywordTimeFilter);
  }
  if (institution_ids?.length > 0) {
    institution_ids.forEach((e) => {
      searchParams.append("institution_ids", e);
    });
  }
  if (seniority?.length > 0) {
    seniority.forEach((e) => {
      searchParams.append("seniority", e);
    });
  }
  if (top_k) {
    searchParams.append("top_k", top_k);
  }
  url += `?${searchParams.toString()}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacetSearchAuthorRelatedKeywords = async ({
  keywordQuery,
  top_k,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/facet_search/related_keywords`;
  const searchParams = new URLSearchParams();
  if (keywordQuery?.length > 0) {
    keywordQuery.forEach((e) => {
      searchParams.append("keywordQuery", e);
    });
  }
  if (top_k) {
    searchParams.append("top_k", top_k);
  }
  url += `?${searchParams.toString()}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacetSearchAuthorStates = async ({
  keywordQuery,
  keywordTimeFilter,
  page = 0,
  rowsPerPage,
  numPages,
  seniority,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/facet_search/states`;
  const searchParams = new URLSearchParams();
  if (keywordQuery?.length > 0) {
    keywordQuery.forEach((e) => {
      searchParams.append("keywordQuery", e);
    });
  }
  if (keywordTimeFilter) {
    searchParams.append("keywordTimeFilter", keywordTimeFilter);
  }
  if (seniority?.length > 0) {
    seniority.forEach((e) => {
      searchParams.append("seniority", e);
    });
  }
  searchParams.append("page", page);
  if (rowsPerPage) {
    searchParams.append("rowsPerPage", rowsPerPage);
  }
  if (numPages) {
    searchParams.append("numPages", numPages);
  }
  url += `?${searchParams.toString()}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacetSearchAuthorInstitutions = async ({
  keywordQuery,
  keywordTimeFilter,
  page = 0,
  rowsPerPage,
  numPages,
  seniority,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/facet_search/institutions`;
  const searchParams = new URLSearchParams();
  if (keywordQuery?.length > 0) {
    keywordQuery.forEach((e) => {
      searchParams.append("keywordQuery", e);
    });
  }
  if (keywordTimeFilter) {
    searchParams.append("keywordTimeFilter", keywordTimeFilter);
  }
  if (seniority?.length > 0) {
    seniority.forEach((e) => {
      searchParams.append("seniority", e);
    });
  }
  searchParams.append("page", page);
  if (rowsPerPage) {
    searchParams.append("rowsPerPage", rowsPerPage);
  }
  if (numPages) {
    searchParams.append("numPages", numPages);
  }
  url += `?${searchParams.toString()}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacetSearchAuthorSenority = async ({
  keywordQuery,
  keywordTimeFilter,
  top_k,
  states,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/author/facet_search/seniority`;
  const searchParams = new URLSearchParams();
  if (keywordQuery?.length > 0) {
    keywordQuery.forEach((e) => {
      searchParams.append("keywordQuery", e);
    });
  }
  if (keywordTimeFilter) {
    searchParams.append("keywordTimeFilter", keywordTimeFilter);
  }
  if (states?.length > 0) {
    states.forEach((e) => {
      searchParams.append("states", e);
    });
  }
  if (top_k) {
    searchParams.append("top_k", top_k);
  }
  url += `?${searchParams.toString()}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getSearchAuthorsGraph = (filters, callback) => {
  const { query, ...rest } = filters;
  const axios = AxiosConfigExplore();
  let url = `/author/search/collaborators_graph`;

  axios
    .post(url, {
      ...rest,
      query: Array.isArray(query) ? query : !!query ? [query] : null,
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSuggestSearchAuthors = (params, callback, additionalInfo) => {
  const controller = new AbortController();
  const axios = AxiosConfigExplore();
  let url = `/author/suggest/${params}`;

  const searchParams = new URLSearchParams();
  if (additionalInfo?.unitId) {
    searchParams.append("unitId", additionalInfo.unitId);
  }
  if (additionalInfo?.institutionId) {
    searchParams.append("institutionId", additionalInfo.institutionId);
  }

  if (searchParams.toString().length > 0) {
    url += `?${searchParams.toString()}`;
  }

  axios
    .get(url, {
      signal: controller.signal,
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });

  return controller;
};

export const getRelatedAuthorsById = async ({ id }) => {
  const axios = AxiosConfigExplore();
  const url = `/author/related_faculty?authorId=${id}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const filterScholarsWithFTS = async ({
  page = 0,
  rowsPerPage = 10,
  fullTextSearchQuery,
  ...rest
}) => {
  const axios = AxiosConfigExplore();
  const url = `/author/filter_scholars_with_fts`;
  try {
    const res = await axios.post(url, {
      page,
      rowsPerPage,
      full_text_search_query: fullTextSearchQuery,
      ...rest,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFacultyInternationalCollaborators = async ({
  id,
  country = [],
  keyword = [],
  timeFilter,
}) => {
  const axios = AxiosConfigExplore();
  const searchParams = new URLSearchParams();
  searchParams.append("authorId", id);
  country?.forEach((c) => searchParams.append("country", c));
  keyword?.forEach((e) => searchParams.append("keyword", e));
  if (timeFilter) {
    searchParams.append("timeFilter", timeFilter);
  }
  const url = `/author/international_collaborators?${searchParams.toString()}`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
